import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
// import SingleUnit from '../../assets/images/single-unit.png';
import ProxyBid from "../../components/Modals/ProxyBid";
import Auth from "../../components/Modals/Auth";
import ModalLayout from "../Layouts/ModalLayout/ModalLayout";
import Share from "../../components/Modals/Share";
import { useDispatch, useSelector } from "react-redux";
import { actionsUnit, unitSelector, loadingSelector, imagesSelector } from "../../redux/unit.slice";
import { isLoggedSelector } from "../../redux/auth.slice";
import { useHistory } from "react-router-dom";
// withAuth used by helper; no local API calls here
// import withAuth from '../../services/withAuthProvider';
// import withoutAuth from '../../services/withoutAuthProvider';
// toast used in optimistic helper
import { toggleUnitFavoriteOptimistic } from "../../services/favoriteOptimistic";
// import useOutsideClick from '../../utils/useOutsideClick';
import { SkeletonCustom, SkeletonImage } from "../../components/Skeleton/Skeleton";
// import QuestionMark from '../../assets/icons/QuestionMark';
import NoImage from "../../assets/images/NoImage.jpg";

const defaultImage = NoImage;

export default function FooterUnit() {
  const [isOpenProxyBid, setIsOpenProxyBid] = useState(false);
  // const [isOpenAuth, setIsOpenAuth] = useState(false);
  const [isOpenShare, setIsOpenShare] = useState(false);
  const [isActiveProxyBid, setIsActiveProxyBid] = useState(false);
  // const [isActiveProxyBid, setIsActiveProxyBid] = useState(false);
  const [isLoadingFavorite, setIsLoadingFavorite] = useState(false);
  const unit = useSelector(unitSelector);
  const loading = useSelector(loadingSelector);
  const images = useSelector(imagesSelector);
  const isLogged = useSelector(isLoggedSelector);
  const { push } = useHistory();
  const dispatch = useDispatch();
  const [localIsFavorite, setLocalIsFavorite] = useState(unit?.is_favorite ?? "false");
  const [isOpen, setIsOpen] = useState(false);

  const intervalRef = useRef(null);
  const ref = useRef();

  useEffect(() => {
    setLocalIsFavorite(unit?.is_favorite ?? "false");
  }, [unit?.is_favorite]);

  // useOutsideClick(ref, () => isOpen && setIsOpen(false), true);

  const handleClick = (path) => {
    push(path);
  };

  const openModalProxyBid = () => {
    if (countTimeProxyBid() === true) setIsOpenProxyBid(true);
    // if (countTimeProxyBid() === true) setIsOpenProxyBid(false);
  };

  const closeModalProxyBid = () => {
    setIsOpenProxyBid(false);
  };

  // const openModalAuth = () => {
  //   setIsOpenAuth(true);
  // };
  //
  // const closeModalAuth = () => {
  //   setIsOpenAuth(false);
  // };

  const openModalShare = () => {
    setIsOpenShare(true);
  };

  const closeModalShare = () => {
    setIsOpenShare(false);
  };

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      countTimeProxyBid();
    }, 1000);
    return () => clearInterval(intervalRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unit]);

  function clearTimer() {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  }

  const countTimeProxyBid = () => {
    if (unit) {
      // Check if unit has required auction date and time
      if (!unit.auction_date_start || !unit.auction_time_start) {
        setIsActiveProxyBid(false);
        return false;
      }

      // Create moment object for auction start time
      const auctionStartString = `${unit.auction_date_start} ${unit.auction_time_start}`;
      const auctionStartTime = new Date(auctionStartString);

      // Validate date
      if (isNaN(auctionStartTime.getTime())) {
        setIsActiveProxyBid(false);
        return false;
      }

      const now = new Date();
      const thirtyMinutesBeforeAuction = new Date(auctionStartTime.getTime() - 30 * 60 * 1000);

      // Enable proxy bid if current time is BEFORE 30 minutes before auction start
      // Disable if within 30 minutes or after auction has started
      const shouldEnable = now < thirtyMinutesBeforeAuction && unit?.auction_category !== "CLOSE-BID";

      if (!shouldEnable) {
        return clear();
      }

      setIsActiveProxyBid(true);
      return true;
    }

    function clear() {
      setIsActiveProxyBid(false);
      clearTimer();
      return false;
    }
  };

  const handleToggleFavorite = async () => {
    setIsLoadingFavorite(true);
    // optimistic local update
    const prevLocal = localIsFavorite;
    setLocalIsFavorite((prev) => (prev === "false" ? "true" : "false"));

    // perform optimistic toggle in redux via helper which will revert on failure
    const result = await toggleUnitFavoriteOptimistic({ unit, dispatch, actionsUnit, images });
    if (!result.success) {
      // revert local UI
      setLocalIsFavorite(prevLocal);
    }

    setIsLoadingFavorite(false);
  };

  // const renderTooltip = (props) => (
  //   <Tooltip id="button-tooltip" {...props}>
  //     <p className="mb-1">
  //       Dengan Proxy Bid Anda tidak perlu stand-by di depan layar untuk
  //       melakukan bidding.
  //     </p>
  //     <p>Coming soon.</p>
  //   </Tooltip>
  // );

  return (
    <>
      <div className="unit-footer position-fixed w-100">
        <div className="container">
          <Row>
            <Col lg={5} className="d-none d-lg-block">
              <div className="unit-info" style={{ display: "flex", marginTop: "11px" }}>
                {loading ? (
                  <div className="unit-image">
                    <SkeletonImage />
                  </div>
                ) : (
                  <div
                    className="unit-image"
                    style={
                      unit.pictures?.length > 0
                        ? {
                            position: "relative",
                            float: "left",
                            background: `url("${unit.pictures[0].image_url}")`,
                          }
                        : {
                            position: "relative",
                            float: "left",
                            background: `url(${defaultImage})`,
                          }
                    }
                  ></div>
                )}
                <div style={{ position: "relative", float: "left" }}>
                  {loading ? (
                    <div style={{ width: "200px" }}>
                      <SkeletonCustom width="60%" />
                      <SkeletonCustom />
                    </div>
                  ) : (
                    <>
                      <span className="nomor-lot">
                        Lot{" "}
                        {unit?.lot_number && unit?.auction_lane_name ? unit?.auction_lane_name + unit?.lot_number : ""}
                      </span>
                      <span className="unit-name">
                        {unit?.unit_name || unit?.year + " " + unit?.unit_maker_name + " " + unit?.model_name}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </Col>
            <Col lg={7} md={12} sm={12}>
              <div
                className="d-none d-sm-block"
                style={{
                  position: "relative",
                  float: "right",
                  marginTop: "22px",
                }}
              >
                {loading ? (
                  <div className="d-flex pb-2 gap-2">
                    <SkeletonCustom className="d-inline-block" height="40px" width="150px" />
                    <SkeletonCustom className="d-inline-block" height="40px" width="150px" />
                    <SkeletonCustom className="d-inline-block" height="40px" width="150px" />
                    <SkeletonCustom className="d-inline-block" height="40px" width="40px" />
                    <SkeletonCustom className="d-inline-block" height="40px" width="40px" />
                  </div>
                ) : (
                  <>
                    <span
                      className={`button-footer-unit live-auction `}
                      style={{
                        backgroundColor: unit?.is_cancel_auction === "0" ? "" : "#F5F6F7",
                        color: unit?.is_cancel_auction === "1" ? "gray" : "",
                        cursor: unit?.is_cancel_auction === "1" ? "default" : "pointer",
                      }}
                      onClick={() => {
                        if (unit?.is_cancel_auction === "0") {
                          if (unit?.auction_category === "CLOSE-BID") {
                            handleClick(`/close-bid-auction/${unit?.current_auction_id}/${unit?.id}`);
                          } else if (unit?.auction_category === "TIME-BID") {
                            handleClick(`/time-bid-auction/${unit?.current_auction_id}/${unit?.id}`);
                          } else {
                            handleClick(`/live-auction/${unit?.current_auction_id}`);
                          }
                        }
                      }}
                    >
                      Live Auction
                    </span>
                    <button
                      type="button"
                      onClick={isActiveProxyBid ? openModalProxyBid : null}
                      style={{ cursor: "default", background: "transparent", border: "none", padding: 0 }}
                    >
                      {/* <a style={{ cursor: 'default' }}> */}
                      <span
                        className={`button-footer-unit position-relative proxy-bid ${
                          isActiveProxyBid && unit?.is_cancel_auction === "0" ? "beli-nipl" : "text-secondary "
                        }`}
                        style={{
                          backgroundColor: isActiveProxyBid && unit?.is_cancel_auction === "0" ? "" : "#F5F6F7",
                          color: isActiveProxyBid && unit?.is_cancel_auction === "0" ? "#CF1701" : "",
                        }}
                      >
                        Proxy Bid
                        {/* <span className='ps-1'> </span>
                        <OverlayTrigger
                          placement='top'
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip}
                        >
                          <span className='position-absolute top-0 end-0 pe-1'>
                            <QuestionMark
                              className={`${
                                isActiveProxyBid ? '' : ' text-secondary'
                              }`}
                            />
                          </span>
                        </OverlayTrigger> */}
                      </span>
                    </button>
                    <span
                      className="button-footer-unit beli-nipl cursor-pointer text-danger"
                      onClick={() => push("/beli-nipl", { unit })}
                    >
                      Beli NIPL
                    </span>
                    {localIsFavorite === "false" ? (
                      <span className="button-footer-unit-small cursor-pointer" onClick={handleToggleFavorite}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M15.8335 11.6666V14.1666H18.3335V15.8333H15.8327L15.8335 18.3333H14.1669L14.166 15.8333H11.6669V14.1666H14.1669V11.6666H15.8335ZM16.8694 3.96415C18.7544 5.85415 18.8194 8.86415 17.066 10.8266L15.8827 9.64498C16.9919 8.37498 16.9335 6.38332 15.6894 5.14165C14.4369 3.89248 12.4227 3.83915 11.1144 5.01415L10.0019 6.01248L8.88852 5.01498C7.57602 3.83832 5.56269 3.88998 4.31019 5.14332C3.06852 6.38498 3.00602 8.37248 4.15019 9.68582L11.1769 16.7242L10.0002 17.9042L2.93352 10.8275C1.18019 8.86415 1.24602 5.84915 3.13019 3.96415C5.01769 2.07748 8.03685 2.01415 10.0002 3.77415C11.9577 2.01665 14.9827 2.07498 16.8685 3.96415H16.8694Z"
                            fill="#C20102"
                          />
                        </svg>
                      </span>
                    ) : (
                      <span className="button-footer-unit-small cursor-pointer" onClick={handleToggleFavorite}>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.0009 3.77415C11.9584 2.01665 14.9834 2.07498 16.8693 3.96415C18.7543 5.85415 18.8193 8.86415 17.0659 10.8275L9.99925 17.9042L2.93425 10.8275C1.18092 8.86415 1.24675 5.84915 3.13092 3.96415C5.01842 2.07748 8.03759 2.01415 10.0009 3.77415Z"
                            fill="#C20102"
                          />
                        </svg>
                      </span>
                    )}
                    <button
                      type="button"
                      onClick={openModalShare}
                      className="cursor-pointer"
                      style={{ background: "transparent", border: "none", padding: 0 }}
                    >
                      <span className="button-footer-unit-small">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11.3133 14.3924L7.05492 12.0699C6.64617 12.4757 6.12643 12.7513 5.56125 12.8621C4.99606 12.9729 4.41072 12.9139 3.87903 12.6925C3.34733 12.4711 2.89308 12.0973 2.57355 11.6181C2.25401 11.1389 2.0835 10.5759 2.0835 9.99993C2.0835 9.42399 2.25401 8.86093 2.57355 8.38176C2.89308 7.90258 3.34733 7.52873 3.87903 7.30735C4.41072 7.08596 4.99606 7.02694 5.56125 7.13774C6.12643 7.24853 6.64617 7.52418 7.05492 7.92993L11.3133 5.60743C11.1672 4.92221 11.2727 4.20731 11.6104 3.59347C11.9481 2.97963 12.4955 2.50787 13.1525 2.26446C13.8095 2.02104 14.5321 2.02224 15.1883 2.26783C15.8444 2.51343 16.3902 2.987 16.7259 3.60196C17.0616 4.21692 17.1647 4.93216 17.0164 5.61689C16.8681 6.30162 16.4782 6.91009 15.9182 7.33101C15.3581 7.75194 14.6652 7.9572 13.9663 7.90926C13.2673 7.86132 12.6089 7.56338 12.1116 7.06993L7.85326 9.39243C7.9382 9.79298 7.9382 10.2069 7.85326 10.6074L12.1116 12.9299C12.6089 12.4365 13.2673 12.1385 13.9663 12.0906C14.6652 12.0427 15.3581 12.2479 15.9182 12.6688C16.4782 13.0898 16.8681 13.6982 17.0164 14.383C17.1647 15.0677 17.0616 15.7829 16.7259 16.3979C16.3902 17.0129 15.8444 17.4864 15.1883 17.732C14.5321 17.9776 13.8095 17.9788 13.1525 17.7354C12.4955 17.492 11.9481 17.0202 11.6104 16.4064C11.2727 15.7925 11.1672 15.0776 11.3133 14.3924Z"
                            fill="#C20102"
                          />
                        </svg>
                      </span>
                    </button>
                  </>
                )}
              </div>
              {/* mobile view start here */}
              <div className="group mobile-footer-unit">
                <div
                  className="flex-1 button-footer-unit live-auction"
                  style={{
                    backgroundColor: unit?.is_cancel_auction === "0" ? "" : "#F5F6F7",
                    color: unit?.is_cancel_auction === "1" ? "gray" : "",
                    cursor: unit?.is_cancel_auction === "1" ? "default" : "pointer",
                  }}
                  onClick={() => {
                    if (unit?.is_cancel_auction === "0") {
                      if (unit?.auction_category === "CLOSE-BID") {
                        handleClick(`/close-bid-auction/${unit?.current_auction_id}/${unit?.id}`);
                      } else if (unit?.auction_category === "TIME-BID") {
                        handleClick(`/time-bid-auction/${unit?.current_auction_id}/${unit?.id}`);
                      } else {
                        handleClick(`/live-auction/${unit?.current_auction_id}`);
                      }
                    }
                  }}
                >
                  Live Auction
                </div>
                <button
                  className="button-footer-unit more-fill"
                  style={{ opacity: isLoadingFavorite ? "0.5" : "1" }}
                  onClick={() => setIsOpen(!isOpen)}
                  onBlur={() =>
                    setTimeout(() => {
                      setIsOpen(false);
                    }, 200)
                  }
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4.16667 8.33325C3.25 8.33325 2.5 9.08325 2.5 9.99992C2.5 10.9166 3.25 11.6666 4.16667 11.6666C5.08333 11.6666 5.83333 10.9166 5.83333 9.99992C5.83333 9.08325 5.08333 8.33325 4.16667 8.33325ZM15.8333 8.33325C14.9167 8.33325 14.1667 9.08325 14.1667 9.99992C14.1667 10.9166 14.9167 11.6666 15.8333 11.6666C16.75 11.6666 17.5 10.9166 17.5 9.99992C17.5 9.08325 16.75 8.33325 15.8333 8.33325ZM10 8.33325C9.08333 8.33325 8.33333 9.08325 8.33333 9.99992C8.33333 10.9166 9.08333 11.6666 10 11.6666C10.9167 11.6666 11.6667 10.9166 11.6667 9.99992C11.6667 9.08325 10.9167 8.33325 10 8.33325Z"
                      fill="#1E1E1F"
                    />
                  </svg>
                </button>
              </div>
              <div ref={ref} className={`${isOpen ? "d-block" : "d-none"} more-fill-menu`}>
                {/* <div className="text-secondary" >Proxy Bid</div> */}
                <div
                  onClick={isActiveProxyBid ? openModalProxyBid : null}
                  className={`${isActiveProxyBid ? "cursor-pointer" : "text-secondary "}`}
                >
                  Proxy Bid
                </div>
                <div onClick={() => push("/beli-nipl", { unit })}>Beli NIPL</div>
                {localIsFavorite === "false" ? (
                  <div className=" cursor-pointer" onClick={handleToggleFavorite}>
                    Favorit
                  </div>
                ) : (
                  <div className=" cursor-pointer" onClick={handleToggleFavorite}>
                    Hapus Favorit
                  </div>
                )}
                <div onClick={openModalShare} className="cursor-pointer">
                  Bagikan
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <ModalLayout
        show={isOpenProxyBid}
        handleClose={closeModalProxyBid}
        title={isLogged === true ? "Proxy Bid" : "Masuk"}
        className="modal-detail-unit modal-transaction"
      >
        {isLogged === true ? <ProxyBid handleClose={closeModalProxyBid} /> : <Auth />}
      </ModalLayout>

      <ModalLayout
        show={isOpenShare}
        handleClose={closeModalShare}
        title={"Bagikan"}
        className="modal-detail-unit modal-transaction"
      >
        <Share shareUrl={window.location.origin + "/unit-lelang/" + unit.id} />
      </ModalLayout>
    </>
  );
}
